import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LabelItemComponent } from '@app/pcs/shared/labels/label/label-item.component';
import { LabelsComponent } from '@app/pcs/shared/labels/label/labels.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    LabelItemComponent,
    LabelsComponent
  ],
  exports: [
    LabelItemComponent,
    LabelsComponent
  ]
})
export class LabelModule {
}
